export default {
  screens: [
    {
      type: 'intro',
      title: 'Chaumet世家',
      content: 'Chaumet世家巴黎珠寶問世。',
      idYt: 'Ksm_iOCcZVE',
      videoCover: 'world/home/video.jpg',
      desktop: {
        cover: 'world/home/cover-1.jpg'
      },
      mobile: {
        cover: 'world/home/mobile-cover-1.jpg',
        contentStyle: { width: '90%' },
        coverStyle: {
          width: '60%',
          bottom: '-30%',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      }
    },
    {
      type: 'perspective',
      leftImg: 'world/home/perspectiveLeft.jpg',
      middleImg: 'world/home/perspectiveMiddle.jpg',
      content:
        '1907年，Chaumet遷至凡登廣場12號現址。Chaumet世家的府邸豪宅中設有歷史悠久的精品店、典雅的沙龍、設計工作室和高級珠寶工作坊。',
      cover: 'world/home/cover-2.jpg'
    },
    {
      type: 'shadow',
      desktop: {
        middleImg: 'world/home/shadowMiddle.jpg',
        leftImg: 'world/home/shadowLeft.jpg',
        cover: 'world/home/cover-3.jpg'
      },
      mobile: {
        middleImg: 'world/home/shadowMiddle.jpg',
        leftImg: 'world/home/shadowLeft.jpg',
        cover: 'world/home/mobile-cover-3.jpg',
        coverStyle: {
          width: '79%',
          bottom: '-27%',
          right: '-4%',
          left: 'inherit',
          position: 'absolute'
        }
      },
      content:
        '正是這個輝煌尊貴之地，見證了品牌璀璨的成功歷程。<br><br> 品牌創始人瑪利艾虔·尼鐸(Marie-Etienne Nitot)是富有創新精神的設計師，成功地將自己的工藝技術傳授給繼任之人。'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/cht/worlds/home.js